import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Only mount React if an existing `#root` element is present in the HTML.
// If there's no `#root`, do nothing so the static `public/index.html`
// content remains visible unchanged.
const mountNode = document.getElementById("root");
if (mountNode) {
  console.log("CoWrite: Mounting React App...");
  const root = ReactDOM.createRoot(mountNode);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  console.log("CoWrite: React App Rendered.");
} else {
  // Intentionally not mounting React — leaving static HTML intact.
  // This keeps the `public/index.html` page as the visible page.
  // No further action required.
}
